import { IToast } from '../interfaces/toast';
import { TRANSLATION_COLLABORATORS } from '../translations/collaborators';
import { TRANSLATIONS_GLOBAL } from '../translations/commons';
import { FLEXIBLE_REMUNERATION_TRANSLATIONS } from '../translations/flexibleRemuneration';
import { TRANSLATIONS_REPORTS } from '../translations/reports';
import { TRANSLATIONS_SETTINGS } from '../translations/settings';
import { TRANSLATION_STORIES_CREATE_NEW } from '../translations/stories';

export const DEFAULT_TOAST_DATA: IToast = {
  title: '',
  description: '',
  icon: 'success',
  button: false,
  buttonText: ''
};

export const UPLOAD_FILE_ERROR: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.uploadFileError.title,
  description: TRANSLATIONS_GLOBAL.toasts.uploadFileError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATIONS_GLOBAL.toasts.uploadFileError.buttonText
};

export const DOWNLOAD_TEMPLATE_ERROR: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.downloadTemplateError.title,
  description: TRANSLATIONS_GLOBAL.toasts.downloadTemplateError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATIONS_GLOBAL.toasts.downloadTemplateError.buttonText
};

export const UPDATE_USER_PASSWORD_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.updateUserPassSuccess.title,
  description: TRANSLATIONS_GLOBAL.toasts.updateUserPassSuccess.description,
  icon: 'success',
  button: true,
  buttonText: TRANSLATIONS_GLOBAL.toasts.updateUserPassSuccess.buttonText
};

export const UPDATE_USER_IMAGE_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_SETTINGS.error.image.snackbarTitle,
  description: TRANSLATIONS_SETTINGS.error.image.generic,
  icon: 'error',
  button: true,
  buttonText: TRANSLATIONS_SETTINGS.error.buttonText
};

export const UPDATE_USER_IMAGE_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_SETTINGS.success.image.snackbarTitle,
  description: TRANSLATIONS_SETTINGS.success.image.description,
  icon: 'success',
  button: true,
  buttonText: TRANSLATIONS_SETTINGS.success.buttonText
};

export const UPDATE_USER_DATA_SUCCESS_TOAST: IToast = {
  description: TRANSLATIONS_SETTINGS.success.personalData.description,
  icon: 'success',
  title: TRANSLATIONS_SETTINGS.success.personalData.snackbarTitle,
  buttonText: TRANSLATIONS_SETTINGS.success.buttonText,
  button: true
};

export const UPDATE_USER_DATA_ERROR_TOAST: IToast = {
  description: TRANSLATIONS_SETTINGS.error.personalData.description,
  icon: 'error',
  title: TRANSLATIONS_SETTINGS.error.personalData.snackbarTitle,
  buttonText: TRANSLATIONS_SETTINGS.error.buttonText,
  button: true
};

export const UPDATE_BUSINESS_HOLDING_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.updateHoldingSuccess.title,
  description: TRANSLATIONS_GLOBAL.toasts.updateHoldingSuccess.description,
  icon: 'success',
  button: true,
  buttonText: TRANSLATIONS_GLOBAL.toasts.updateHoldingSuccess.buttonText
};

export const UPDATE_BUSINESS_COMPANY_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.updateCompanySuccess.title,
  description: TRANSLATIONS_GLOBAL.toasts.updateCompanySuccess.description,
  icon: 'success',
  button: true,
  buttonText: TRANSLATIONS_GLOBAL.toasts.updateCompanySuccess.buttonText
};

export const UPDATE_BUSINESS_HOLDING_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.updateHoldingError.title,
  description: TRANSLATIONS_GLOBAL.toasts.updateHoldingError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATIONS_GLOBAL.toasts.updateHoldingError.buttonText
};

export const UPDATE_BUSINESS_COMPANY_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.updateCompanyError.title,
  description: TRANSLATIONS_GLOBAL.toasts.updateCompanyError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATIONS_GLOBAL.toasts.updateCompanyError.buttonText
};

export const UPDATE_USER_LOCALE_SUCCESS_TOAST: IToast = {
  description: TRANSLATIONS_SETTINGS.success.lenguageSelector.description,
  icon: 'success',
  title: TRANSLATIONS_SETTINGS.success.lenguageSelector.snackbarTitle,
  buttonText: TRANSLATIONS_SETTINGS.success.buttonText,
  button: true
};

export const UPDATE_USER_LOCALE_ERROR_TOAST: IToast = {
  description: TRANSLATIONS_SETTINGS.error.lenguageSelector.description,
  icon: 'error',
  title: TRANSLATIONS_SETTINGS.error.lenguageSelector.snackbarTitle,
  buttonText: TRANSLATIONS_SETTINGS.error.buttonText,
  button: true
};

export const HIDE_STORY_SUCCESS_TOAST: IToast = {
  description: TRANSLATIONS_GLOBAL.toasts.hideStorySuccess.description,
  icon: 'success',
  title: TRANSLATIONS_GLOBAL.toasts.hideStorySuccess.title,
  buttonText: TRANSLATIONS_GLOBAL.toasts.hideStorySuccess.buttonText,
  button: true
};

export const HIDE_STORY_ERROR_TOAST: IToast = {
  description: TRANSLATIONS_GLOBAL.toasts.hideStoryError.description,
  icon: 'error',
  title: TRANSLATIONS_GLOBAL.toasts.hideStoryError.title,
  buttonText: TRANSLATIONS_GLOBAL.toasts.hideStoryError.buttonText,
  button: true
};

export const PUBLISH_STORY_SUCCESS_TOAST: IToast = {
  title: TRANSLATION_STORIES_CREATE_NEW.toasts.publishSuccess.title,
  description: TRANSLATION_STORIES_CREATE_NEW.toasts.publishSuccess.description,
  icon: 'success',
  button: true,
  buttonText: TRANSLATION_STORIES_CREATE_NEW.toasts.buttonText
};

export const PROGRAM_STORY_SUCCESS_TOAST: IToast = {
  title: TRANSLATION_STORIES_CREATE_NEW.toasts.programSuccess.title,
  description: TRANSLATION_STORIES_CREATE_NEW.toasts.programSuccess.description,
  icon: 'success',
  button: true,
  buttonText: TRANSLATION_STORIES_CREATE_NEW.toasts.buttonText
};

export const PUBLISH_STORY_ERROR_TOAST: IToast = {
  title: TRANSLATION_STORIES_CREATE_NEW.toasts.publishError.title,
  description: TRANSLATION_STORIES_CREATE_NEW.toasts.publishError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATION_STORIES_CREATE_NEW.toasts.buttonText
};

export const UPLOAD_STORY_ERROR_TOAST: IToast = {
  title: TRANSLATION_STORIES_CREATE_NEW.toasts.uploadError.title,
  description: TRANSLATION_STORIES_CREATE_NEW.toasts.uploadError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATION_STORIES_CREATE_NEW.toasts.buttonText
};

export const UPLOAD_STORY_SERVICE_ERROR_TOAST: IToast = {
  title: TRANSLATION_STORIES_CREATE_NEW.toasts.uploadServiceError.title,
  description: TRANSLATION_STORIES_CREATE_NEW.toasts.uploadServiceError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATION_STORIES_CREATE_NEW.toasts.buttonText
};

export const INVALID_FORMAT_STORY_ERROR_TOAST: IToast = {
  title: TRANSLATION_STORIES_CREATE_NEW.toasts.invalidFormatError.title,
  description: TRANSLATION_STORIES_CREATE_NEW.toasts.invalidFormatError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATION_STORIES_CREATE_NEW.toasts.buttonText
};

export const MAX_SIZE_IMAGE_STORY_ERROR_TOAST: IToast = {
  title: TRANSLATION_STORIES_CREATE_NEW.toasts.maxSizeImgError.title,
  description: TRANSLATION_STORIES_CREATE_NEW.toasts.maxSizeImgError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATION_STORIES_CREATE_NEW.toasts.buttonText
};

export const MAX_SIZE_VIDEO_STORY_ERROR_TOAST: IToast = {
  title: TRANSLATION_STORIES_CREATE_NEW.toasts.maxSizeVideoError.title,
  description: TRANSLATION_STORIES_CREATE_NEW.toasts.maxSizeVideoError.description,
  icon: 'error',
  button: true,
  buttonText: TRANSLATION_STORIES_CREATE_NEW.toasts.buttonText
};

export const DOWNLOAD_MEMBERS_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.downloadMembersError.title,
  description: TRANSLATIONS_GLOBAL.toasts.downloadMembersError.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const DELETE_CHALLENGE_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.deleteChallengeSuccess.title,
  description: '',
  icon: 'success',
  button: true,
  buttonText: ''
};

export const CREATE_CHALLENGE_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.createChallengeSuccess.title,
  description: TRANSLATIONS_GLOBAL.toasts.createChallengeSuccess.description,
  icon: 'success',
  button: true,
  buttonText: ''
};

export const DELETE_CHALLENGE_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.deleteChallengeError.title,
  description: TRANSLATIONS_GLOBAL.toasts.deleteChallengeError.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const CREATE_CHALLENGE_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.createChallengeError.title,
  description: TRANSLATIONS_GLOBAL.toasts.createChallengeError.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const DELETE_COLLABORATOR_SUCCESS_TOAST: IToast = {
  title: TRANSLATION_COLLABORATORS.table.toasts.deleteCollaborator.title,
  description: '',
  icon: 'success',
  button: true,
  buttonText: ''
};

export const DELETE_COLLABORATOR_ERROR_TOAST: IToast = {
  title: TRANSLATION_COLLABORATORS.table.toasts.error.title,
  description: TRANSLATION_COLLABORATORS.table.toasts.error.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const DELETE_COLLABORATORS_SUCCESS_TOAST: IToast = {
  title: TRANSLATION_COLLABORATORS.table.toasts.deleteCollaborator.title,
  description: '',
  icon: 'success',
  button: true,
  buttonText: ''
};

export const DELETE_COLLABORATORS_ERROR_TOAST: IToast = {
  title: TRANSLATION_COLLABORATORS.table.toasts.error.title,
  description: TRANSLATION_COLLABORATORS.table.toasts.error.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const RESEND_EMAIL_SUCCESS_TOAST: IToast = {
  title: TRANSLATION_COLLABORATORS.table.toasts.resendEmail.title,
  description: '',
  icon: 'success',
  button: true,
  buttonText: ''
};

export const RESEND_EMAIL_ERROR_TOAST: IToast = {
  title: TRANSLATION_COLLABORATORS.table.toasts.error.title,
  description: TRANSLATION_COLLABORATORS.table.toasts.error.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const GENERIC_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.genericError.title,
  description: TRANSLATIONS_GLOBAL.toasts.genericError.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const ADD_COLLABORATOR_SUCCESS_TOAST: IToast = {
  title: TRANSLATION_COLLABORATORS.toast.successAddCollaborator.title,
  description: TRANSLATION_COLLABORATORS.toast.successAddCollaborator.subtitle,
  icon: 'success',
  button: true,
  buttonText: ''
};

export const ADD_COLLABORATOR_FAILED_TOAST: IToast = {
  title: TRANSLATION_COLLABORATORS.table.toasts.error.title,
  description: TRANSLATION_COLLABORATORS.table.toasts.error.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const DELETE_COLLABORATOR_SUCCESS_TOAST_NE: IToast = {
  title: TRANSLATION_COLLABORATORS.toast.successDeleteCollaborator.title,
  description: TRANSLATION_COLLABORATORS.toast.successAddCollaborator.subtitle,
  icon: 'success',
  button: true,
  buttonText: ''
};

export const COLLABORATOR_LIMIT_ERROR_TOAST_NE: IToast = {
  title: TRANSLATION_COLLABORATORS.toast.errorCollaboratorLimit.title,
  description: TRANSLATION_COLLABORATORS.toast.errorCollaboratorLimit.subtitle,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const DOWNLOAD_TEMPLATE_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.downloadSubsTemplate.success.title,
  description: TRANSLATIONS_GLOBAL.toasts.downloadSubsTemplate.success.description,
  icon: 'success',
  button: true,
  buttonText: ''
};

export const DOWNLOAD_TEMPLATE_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.downloadSubsTemplate.error.title,
  description: TRANSLATIONS_GLOBAL.toasts.downloadSubsTemplate.error.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const UPSELL_REQUEST_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.upsellRequestSuccess.title,
  description: TRANSLATIONS_GLOBAL.toasts.upsellRequestSuccess.description,
  icon: 'success',
  button: true,
  buttonText: ''
};

export const NOTIFY_ADD_FOUNDS_SUCCESS_TOAST: IToast = {
  title: FLEXIBLE_REMUNERATION_TRANSLATIONS.balanceToastSuccess.title,
  description: FLEXIBLE_REMUNERATION_TRANSLATIONS.balanceToastSuccess.description,
  icon: 'success',
  button: true,
  buttonText: ''
};

export const DATA_COPIED_TO_CLIPBOARD_TOAST: IToast = {
  title: '',
  description: FLEXIBLE_REMUNERATION_TRANSLATIONS.copyData.title,
  icon: 'success',
  button: true,
  buttonText: ''
};

export const DOWNLOAD_REPORT_RF_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_REPORTS.rf.toast.success.title,
  description: TRANSLATIONS_REPORTS.rf.toast.success.description,
  icon: 'success',
  button: true,
  buttonText: ''
};

export const DOWNLOAD_REPORT_DEFAULT_SUCCESS_TOAST: IToast = {
  title: TRANSLATIONS_REPORTS.default.toast.success.title,
  description: TRANSLATIONS_REPORTS.default.toast.success.description,
  icon: 'success',
  button: true,
  buttonText: ''
};

export const DOWNLOAD_REPORT_RF_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_REPORTS.rf.toast.error.title,
  description: TRANSLATIONS_REPORTS.rf.toast.error.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const DOWNLOAD_REPORT_DEFAULT_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_REPORTS.default.toast.error.title,
  description: TRANSLATIONS_REPORTS.default.toast.error.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const ADD_DEPENDENTS_LIMIT_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.addDependentsLimitError.title,
  description: TRANSLATIONS_GLOBAL.toasts.addDependentsLimitError.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const ADD_DEPENDENTS_FORMAT_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.addDependentsFormatError.title,
  description: TRANSLATIONS_GLOBAL.toasts.addDependentsFormatError.description,
  icon: 'error',
  button: true,
  buttonText: ''
};

export const APPROVE_RF_REQUEST_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.requests.approved.title,
  description: '',
  icon: 'success',
  button: true,
  buttonText: ''
};

export const REJECT_RF_REQUEST_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.requests.rejected.title,
  description: '',
  icon: 'success',
  button: true,
  buttonText: ''
};

export const CANCEL_RF_REQUEST_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.requests.cancelled.title,
  description: '',
  icon: 'success',
  button: true,
  buttonText: ''
};

export const CANCEL_RF_INSURANCE_REQUEST_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.requests.cancelled.insuranceTitle,
  description: '',
  icon: 'success',
  button: true,
  buttonText: ''
};

export const LOGIN_ERROR_TOAST: IToast = {
  title: TRANSLATIONS_GLOBAL.toasts.loginError.title,
  description: TRANSLATIONS_GLOBAL.toasts.loginError.description,
  icon: 'error',
  button: true,
  buttonText: ''
};
